// extracted by mini-css-extract-plugin
export default {"removeBorder":"fileInputField_removeBorder__Oj-57","fitContent":"fileInputField_fitContent__d11Ha"};